<template>
    <div class="cancellation-table-row" :class="{ active: row.active }">
        <span class="cancellation-table-row-label">{{ row.label }}</span>
        <Badge
            v-if="row.refundable"
            color="green"
            size="l"
            :text="t({ key: 'cancellation.free_cancellation' })" />
        <span v-else class="cancellation-table-row-cost">
            {{ getMoneyObjectAsString(row.cost) }}
        </span>
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, PropType } from 'vue';
    import { getMoneyObjectAsString } from '@shared/helpers/money';
    import { CancellationTableRow } from './CancellationTable.interfaces';
    import Badge from '@ui/components/Badge/Badge.vue';

    export default defineComponent({
        name: 'Row',
        methods: { t, getMoneyObjectAsString },
        components: { Badge },
        props: {
            row: {
                type: Object as PropType<CancellationTableRow>,
                required: true,
            },
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'CancellationTable';
</style>
